import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icons/person_gray_150.png'


const _withScopeId = n => (_pushScopeId("data-v-14763218"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_2 = { class: "modal-content" }
const _hoisted_3 = { class: "modal-header" }
const _hoisted_4 = { class: "modal-title" }
const _hoisted_5 = { class: "comment-count" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}, null, -1))
const _hoisted_7 = { class: "modal-body" }
const _hoisted_8 = { class: "comment-header" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "comment-avatar"
}, null, -1))
const _hoisted_10 = { class: "comment-author" }
const _hoisted_11 = { class: "comment-time" }
const _hoisted_12 = { class: "comment-text" }
const _hoisted_13 = {
  key: 1,
  class: "no-comments text-muted text-center"
}
const _hoisted_14 = { class: "modal-footer-input" }
const _hoisted_15 = { class: "d-flex justify-content-end" }
const _hoisted_16 = ["disabled"]

import { computed, ref, onMounted, onBeforeUnmount, onUnmounted } from 'vue'
import { Modal as BsModal } from 'bootstrap'
import { useCommentStore, type Comment } from '@/rd/CommentStore'


export default /*#__PURE__*/_defineComponent({
  __name: 'CommentModal',
  emits: ["commentAdded"],
  setup(__props, { expose: __expose, emit }) {



__expose({ open, close })

const commentStore = useCommentStore()
const modalElemRef = ref<HTMLElement>()
const contentIdRef = ref('')
const newCommentText = ref('')

const comments = computed<Comment[]>(() => {
  if (!contentIdRef.value) {
    return []
  }
  return commentStore.getComments(contentIdRef.value)
})

onMounted(() => {
  modalElemRef.value?.addEventListener('hidden.bs.modal', onHidden)
})

onBeforeUnmount(() => {
  close()
})

onUnmounted(() => {
  modalElemRef.value?.removeEventListener('hidden.bs.modal', onHidden)
})

function onHidden() {
  contentIdRef.value = ''
  newCommentText.value = ''
}

function open(contentId: string) {
  contentIdRef.value = contentId
  newCommentText.value = ''
  BsModal.getOrCreateInstance(modalElemRef.value!).show()
}

function close() {
  BsModal.getInstance(modalElemRef.value!)?.hide()
}

function submitComment() {
  const text = newCommentText.value.trim()
  if (!text) {
    return
  }

  commentStore.addComment(contentIdRef.value, text)
  newCommentText.value = ''
  emit('commentAdded')
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "modalElemRef",
    ref: modalElemRef,
    class: "modal comment-modal",
    tabindex: "-1",
    "data-bs-backdrop": "true",
    "aria-hidden": "true"
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("h5", _hoisted_4, [
            _createTextVNode("Comments "),
            _createElementVNode("span", _hoisted_5, "(" + _toDisplayString(comments.value.length) + ")", 1)
          ]),
          _hoisted_6
        ]),
        _createElementVNode("div", _hoisted_7, [
          (comments.value.length)
            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(comments.value, (comment) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: comment.id,
                  class: "comment-item"
                }, [
                  _createElementVNode("div", _hoisted_8, [
                    _hoisted_9,
                    _createElementVNode("span", _hoisted_10, _toDisplayString(comment.authorName), 1),
                    _createElementVNode("span", _hoisted_11, _toDisplayString(comment.timestamp.toRelative()), 1)
                  ]),
                  _createElementVNode("div", _hoisted_12, _toDisplayString(comment.text), 1)
                ]))
              }), 128))
            : (_openBlock(), _createElementBlock("div", _hoisted_13, " No comments yet "))
        ]),
        _createElementVNode("div", _hoisted_14, [
          _withDirectives(_createElementVNode("textarea", {
            class: "form-control comment-input mb-2",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((newCommentText).value = $event)),
            placeholder: "Add a comment...",
            rows: "3"
          }, null, 512), [
            [_vModelText, newCommentText.value]
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-primary btn-sm",
              disabled: !newCommentText.value.trim(),
              onClick: submitComment
            }, "Post", 8, _hoisted_16)
          ])
        ])
      ])
    ])
  ], 512))
}
}

})